import {TrendUnit} from 'common/report/models/funnels/types';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {XAxisLabelOptions} from 'common/components/line-chart/types';

export function getXAxisLabelStepAndStagger(dateRange: Partial<DateRange>, trendUnit: TrendUnit): XAxisLabelOptions {
  const label: XAxisLabelOptions = {};
  const staggerAndStepCountDefault = 1;
  const staggerAndStepCount = 2;

  if (dateRange && dateRange.window) {
    switch (trendUnit) {
      case TrendUnit.Day:
        if (!(dateRange.window.value <= 7 && dateRange.window.unit.toString() === TrendUnit.Day)) {
          label.staggerLines = staggerAndStepCount;
          label.step = staggerAndStepCount;
        }
        break;
      case TrendUnit.Week:
        if (dateRange.window.value >= 3 && dateRange.window.unit.toString() === TrendUnit.Month) {
          label.staggerLines = staggerAndStepCount;
          label.step = staggerAndStepCount;
        }
        break;
      case TrendUnit.Month:
        if (dateRange.window.value >= 6 && dateRange.window.unit.toString() === TrendUnit.Month) {
          label.staggerLines = staggerAndStepCount;
          label.step = staggerAndStepCountDefault;
        }
    }
  }

  return label;
}
